var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"game-item-operate"},[_c('span',{on:{"click":function($event){return _vm.doOperate(_vm.gameInfo, 'recharge')}}},[_vm._v("充值")]),_vm._v(" "),_c('span',{on:{"click":function($event){return _vm.doOperate(_vm.gameInfo, 'download')}}},[_vm._v("下载")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60c588fc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OperateBtns.vue
// module id = null
// module chunks = 